// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
export function Controller(
    $scope,
    $state,
    $uibModal,
    Alert,
    DestructiveOperationModal,
    PhotoUploadService,
    SaaspassConnectOverviewService,
) {
    this.$onInit = () => {
    const companyId = this.companyId;
    const connectId = this.connectId;

    $scope.basicProfileData=false;
    $scope.extendedProfileData=false;

    $scope.staticUrlPart= window.env.urls.minoCdn;
    $scope.photoFile = null;

    $scope.saveConnect=function() {
        
        SaaspassConnectOverviewService.saaspassConnect.updateSaaspassConnect({
            companyId : companyId,
            connectId:connectId
        },$scope.connectApplication).$promise.then(function(data) {
            $state.reload('company.saaspass-connect');
            Alert('success', 'saaspass_connect.update_success');
        });
    }
    
    $scope.fileNameChanged = function (ele) {
        var photo = ele;
        if (photo.size > 1000000) {
            Alert('danger', 'Photo should be smaller than 1MB');
        } else {
            $scope.photoFile=photo;
        }
      }
    
    $scope.uploadFile = function() {
            var uploadUrl = "app/rest/admin/company/:companyId/saaspassconnects/:id/photo";
            uploadUrl = uploadUrl.replace(":companyId", companyId);
            uploadUrl = uploadUrl.replace(":id", $scope.connectApplication.id);
            PhotoUploadService.upload( $scope.photoFile,  $scope.connectApplication.id,uploadUrl, function(data) {
                $state.reload('company.saaspass-connect');
                Alert('success', 'saaspass_connect.updload_success');
            }, function(response) {               
                $scope.photoFile = null;
                $('#photoUploadInput').val(null);
            });
        
    }
    
        const data = this.connectApplication;
        $scope.connectApplication=data;
        $scope.connectApplication.userProfileScopeRequested=data.oauthClientDetails.oauthScopes.indexOf('profile')!=-1;
        $scope.connectApplication.userEmailScopeRequested=true;
        $scope.connectApplication.userPhoneScopeRequested=data.oauthClientDetails.oauthScopes.indexOf('phone')!=-1;
        $scope.connectApplication.userAddressScopeRequested=data.oauthClientDetails.oauthScopes.indexOf('address')!=-1;

    $scope.showDeleteModal = function() {
        $uibModal
            .open({component: 'confirmDeleteSaaspassConnect'}).result
            .then(() => $scope.preDeleteApplicationDO());
    }
    function getDestructiveOpUrl() {
        return 'app/rest/admin/company/' + companyId + '/saaspassconnects/' + connectId
                + '/delete';
    }
    $scope.preDeleteApplicationDO = function() {
        DestructiveOperationModal({
            titleKey: 'saaspass_connect.destructive_op.delete_title',
            textKey: 'saaspass_connect.destructive_op.delete_text',
            http: {method: 'DELETE', url: getDestructiveOpUrl()}
        }).then(() => {
            $scope.saaspassConnectDeleted();
        });
    }
    $scope.saaspassConnectDeleted = function() {
        Alert('success', 'saaspass_connect.delete_success');
        $state.go('company.saaspass-connect', {}, {reload: 'company.saaspass-connect'});
    }

    $scope.addUpdateSaaspassConnectTemplateUrl = require('../../add-update.html');
    $scope.saaspassConnectInformationTemplateUrl = require('./info.html');
    };
}


// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-connect/manage/overview/overview.controller.js